import React, { useState } from "react";
import styled from "styled-components";

const sections = [
  {
    title: "Welcome to FineChek (A) Systems",
    text: "At FineChek (A) Systems, we are driven by our commitment to excellence in providing Scientific Instruments, industrial laboratory equipment, reagents and consumables. Our mission is to support the scientific and industrial laboratories worldwide by providing reliable, high-quality products that enhance efficiency, accuracy, and safety in every operation.",
  },
  {
    title: "Our Mission",
    text: "Our mission is to empower industries and laboratories with cutting-edge tools and solutions that enable them to perform at their best. We strive to provide products that not only meet the current demands of our clients but also anticipate future needs, ensuring long-term value and sustainability.",
  },
  {
    title: "What We Do",
    text: "FineChek specializes in the production, and supply of a wide range of scientific and industrial laboratory equipment, as well as high-performance reagents. Our products are integral to various sectors, including manufacturing, research and development, quality control, and more. From robust industrial machinery to precise laboratory instruments, we offer solutions that are essential for operational success and innovation.",
  },
  {
    title: "Our Commitment to Quality",
    text: "Quality is the cornerstone of our operations. We are dedicated to maintaining the highest standards in our manufacturing processes, ensuring that every piece of equipment and every reagent we produce is reliable, durable, and effective. Our commitment to quality extends to our customer service, where we aim to provide unparalleled support to help our clients achieve their goals.",
  },
  {
    title: "Innovation and Excellence",
    text: "Innovation is at the core of FineChek. We continually invest in research and development to stay ahead of technological advancements and industry trends. Our team of experts is passionate about creating innovative solutions that improve efficiency, reduce costs, and contribute to the overall success of our clients. We believe that excellence is achieved through continuous improvement and a dedication to pushing the boundaries of what's possible.",
  },
  {
    title: "Global Reach, Local Expertise",
    text: "While FineChek operates on a global scale, we understand the importance of catering to the specific needs of local markets. We collaborate closely with our clients to ensure that our products and services are tailored to their unique requirements. Our global reach combined with local expertise allows us to make a significant impact in diverse industries and regions.",
  },
  {
    title: "Partner with Us",
    text: "At FineChek, we see ourselves as more than just a manufacturer, we are a trusted partner in your success. We are committed to providing the tools and support you need to thrive in a competitive environment. Join us on our journey as we continue to innovate, lead, and make a difference in the industrial and laboratory sectors.",
  },
];

function ArrowIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 17L17 7M17 7H9M17 7V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function Aboutus() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <Wrapper id="about-us">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">About Us</h1>
          </HeaderInfo>

          <AccordionList>
            {sections.map((section, index) => {
              const isOpen = index === openIndex;
              return (
                <Item key={section.title} className={isOpen ? "open radius8" : "radius8"}>
                  <ItemHeader
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    aria-expanded={isOpen}
                  >
                    <HeaderLeft>
                      {isOpen ? (
                        <Number className="whiteColor font15 extraBold">
                          {String(index + 1).padStart(2, "0")}
                        </Number>
                      ) : (
                        <PlainNumber className="font15 extraBold">
                          {String(index + 1).padStart(2, "0")}
                        </PlainNumber>
                      )}
                      <h3 className="font20 extraBold">{section.title}</h3>
                    </HeaderLeft>
                    <IconButton className={isOpen ? "open" : ""}>
                      <ArrowIcon />
                    </IconButton>
                  </ItemHeader>
                  <Panel className={isOpen ? "open" : ""}>
                    <PanelInner>
                      <p className="font13">{section.text}</p>
                    </PanelInner>
                  </Panel>
                </Item>
              );
            })}
          </AccordionList>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;

const HeaderInfo = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const AccordionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 820px;
  margin: 0 auto;
`;

const Item = styled.div`
  border: 1px solid #ececec;
  transition: background-color 0.3s ease, border-color 0.3s ease;
  &.open {
    background-color: rgba(119, 31, 115, 0.06);
    border-color: transparent;
  }
`;

const ItemHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 25px;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  h3 {
    margin: 0;
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const Number = styled.div`
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgb(119, 31, 115);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PlainNumber = styled.div`
  flex-shrink: 0;
  width: 36px;
  color: #c9c9c9;
`;

const IconButton = styled.div`
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e2e2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0b093b;
  transition: transform 0.3s ease, background-color 0.3s ease;
  &.open {
    background-color: #fff;
    transform: rotate(90deg);
  }
`;

const Panel = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.35s ease;
  &.open {
    grid-template-rows: 1fr;
  }
`;

const PanelInner = styled.div`
  overflow: hidden;
  padding: 0 25px;
  p {
    padding-bottom: 25px;
    line-height: 1.6;
    color: #707070;
  }
`;
